import { render, staticRenderFns } from "./PatientDetails.vue?vue&type=template&id=2a45644c&scoped=true"
import script from "./PatientDetails.vue?vue&type=script&lang=js"
export * from "./PatientDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientDetails.vue?vue&type=style&index=0&id=2a45644c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45644c",
  null
  
)

export default component.exports